export default __webpack_public_path__ + "static/media/Icon_Account_CreateAccount.5e1538d4.svg";